import React from "react";
import styled, { css } from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleLeft, faAngleRight } from "@fortawesome/pro-regular-svg-icons";
import { Link } from "react-router-dom";

const Paginations = styled.div`
  ${({ theme }) => {
    return css`
      width: 100%;
      display: flex;
      ul {
        width: 100%;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        padding: ${theme.paddings.sm};
        li {
          margin: 0 ${theme.margins.xs};
          justify-content: center;
          .page-link {
            background-color: white;
            display: flex;
            height: 40px;
            width: 40px;
            justify-content: center;
            align-items: center;
            border: solid 1px #eee;
            font-size: ${theme.fonts.size.base};
            border-radius: 5px;
            :hover {
              background: ${theme.colors.lightprimary};
            }
          }
        }
        li.active {
          .page-link {
            background: ${theme.colors.lightprimary};
            color: ${theme.colors.primary};
          }
        }
      }
    `;
  }}
`;

const Item = ({ currentPage, baseUrl, startPage, endPage, totalPage }) => {
  let pages = [];
  let page = parseInt(currentPage);

  for (var i = startPage; i <= endPage && i <= totalPage; i++) {
    if (i === page) {
      pages.push(
        <li
          className={"page-item " + (i === page ? "active" : "")}
          key={"pagination" + i}
        >
          <div className="page-link" title="현재 페이지" to="#">
            {currentPage}
          </div>
        </li>
      );
    } else {
      pages.push(
        <li className="page-item" key={"pagination" + i}>
          <Link
            className="page-link"
            title={i + " 페이지 이동"}
            to={baseUrl + "page=" + i}
          >
            {i}
          </Link>
        </li>
      );
    }
  }
  return pages;
};

const Pagination = ({
  totalRecord,
  blockSize,
  pageSize,
  currentPage,
  baseUrl,
}) => {
  const currentBlock = Math.ceil(currentPage / blockSize);
  const totalPage = Math.ceil(totalRecord / pageSize);
  const totalBlock = Math.ceil(totalPage / blockSize);

  const startPage = (currentBlock - 1) * blockSize + 1;
  const endPage = currentBlock * blockSize;

  const prevBlockPage = startPage - 1;
  const nextBlockPage = endPage + 1;

  return (
    <Paginations>
      <ul>
        {currentBlock === 1 ? (
          <></>
        ) : (
          <>
            {/* <li className="page-item" key={"paginationFirst"}>
              <Link
                className="page-link"
                title="첫 페이지 보기"
                to={baseUrl + "page=1"}
              >
                <FontAwesomeIcon
                  icon={faAngleDoubleLeft}
                  color="#999"
                  size="lg"
                />
              </Link>
            </li> */}
            <li className="page-item" key={"paginationPrev"}>
              <Link
                className="page-link"
                title={"이전 " + blockSize + "페이지 보기"}
                to={baseUrl + "page=" + prevBlockPage}
              >
                <FontAwesomeIcon icon={faAngleLeft} color="#999" size="lg" />
              </Link>
            </li>
          </>
        )}
        <Item
          currentPage={currentPage}
          baseUrl={baseUrl}
          startPage={startPage}
          endPage={endPage}
          totalPage={totalPage}
        />
        {currentBlock === totalBlock ? (
          <></>
        ) : (
          <>
            <li className="page-item" key={"paginationNext"}>
              <Link
                className="page-link"
                title={"다음 " + nextBlockPage + "페이지 보기"}
                to={baseUrl + "page=" + nextBlockPage}
              >
                <FontAwesomeIcon icon={faAngleRight} color="#999" size="lg" />
              </Link>
            </li>
            {/* <li className="page-item" key={"paginationLast"}>
              <Link
                className="page-link"
                title="마지막 페이지 보기"
                to={baseUrl + "page=" + totalPage}
              >
                <FontAwesomeIcon
                  icon={faAngleDoubleRight}
                  color="#999"
                  size="lg"
                />
              </Link>
            </li> */}
          </>
        )}
      </ul>
    </Paginations>
  );
};

export default Pagination;
